<template>
  <div class="set-info" v-if="productPanelInfo || (hasBadge && productBadgeDescription) || (hasSets && price < priceOld) || (arrivalDateEmployee && isManager)">
    <div class="set-info__attention">
      <svg width="20"
           height="20"
           viewBox="0 0 20 20"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5229 0 20 4.47715 20 10C19.9939 15.5203 15.5203 19.9939 10 20ZM2 10.172C2.04732 14.5732 5.64111 18.1095 10.0425 18.086C14.444 18.0622 17.9995 14.4875 17.9995 10.086C17.9995 5.6845 14.444 2.10977 10.0425 2.086C5.64111 2.06246 2.04732 5.59876 2 10V10.172ZM12 15H9V11H8V9H11V13H12V15ZM11 7H9V5H11V7Z" fill="#FF2F00"/>
      </svg>
    </div>
    <div class="set-info__title-wrap" v-if="productPanelInfo" v-html="productPanelInfo"></div>
    <div class="set-info__title-wrap" v-else-if="hasBadge && productBadgeDescription" v-html="productBadgeDescription"></div>
    <div class="set-info__title-wrap" v-else-if="!hasSets && price < priceOld" v-html="$t('fake_sales_badges_description')"></div>
    <div class="set-info__title-wrap" v-if="arrivalDateEmployee && isManager">
      <br v-if="hasBadge">
      <span v-html="arrivalDateEmployee"></span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ProductBadgeDescription',
  computed: {
    ...mapGetters(['isManager']),
    ...mapState({
      hasSets: state => state.productInfo.productInfo.hasSets,
      hasBadge: state => state.productInfo.productInfo.hasBadge,
      price: state => state.productInfo.productInfo.price,
      priceOld: state => state.productInfo.productInfo.priceOld,
      productBadgeDescription: state => state.productInfo.productInfo.productBadgeDescription,
      arrivalDateEmployee: state => state.productInfo.productInfo.arrivalDateEmployee,
      productPanelInfo: state => state.productInfo.productInfo.productPanelInfo
    })
  }
}
</script>

<style scoped lang="sass">
.set-info
  padding: 12px 15px
  border: 1px solid #E7E7E7
  border-radius: 3px
  display: flex
  align-items: flex-start
  flex-wrap: wrap
  margin-bottom: 10px
  +mmin($tablet)
    margin-bottom: 25px
  &__attention
    width: 20px
    height: 20px
    flex-shrink: 0
    margin-right: 12px
  &__title
    color: #333333
    font-size: 16px
    font-weight: 500
    margin-right: 5px
    &-wrap
      //display: flex
      //flex-wrap: wrap
      //align-items: baseline
      width: calc(100% - 32px)
  &__value
    color: #333333
    font-size: 14px
    font-weight: 400
</style>
